import Cookies from 'js-cookie'

// js-cookie 3.x no longer auto-JSON-stringifies object values on set()
// (2.x did), so the 'language' cookie must be written as an explicit JSON
// string and read defensively: a poisoned value (e.g. "[object Object]")
// must not crash module init, or every refresh becomes a white screen.
function readLanguageCookie() {
  const raw = Cookies.get('language')
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw)
    return (parsed && typeof parsed === 'object') ? parsed : null
  } catch (e) {
    // Self-heal: drop the invalid cookie so the next write stores valid JSON
    Cookies.remove('language')
    return null
  }
}
const languages = readLanguageCookie()

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  languageCode: languages,
  permissionList: []
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  SET_LANAUGE_CODE: (state, languageCode) => {
    state.languageCode = languageCode
    // Explicit JSON.stringify: required since js-cookie 3.x (2.x did it automatically)
    Cookies.set('language', JSON.stringify(languageCode))
  },
  SET_PERMISSION_LIST: (state, permissionList) => {
    state.permissionList = permissionList
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  setLangugeCode({ commit }, languageCode) {
    commit('SET_LANAUGE_CODE', languageCode)
  },
  setPermissionList({ commit }, permissionList) {
    commit('SET_PERMISSION_LIST', permissionList)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
